import { Typography } from '@mui/material';
import { TournamentStatus } from '@okletsplay/core';
import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { useStyles } from './TournamentStatusLabel.styles';

interface TournamentStatusIndicatorProps {
  status: TournamentStatus;
}

export const TournamentStatusLabel: FC<TournamentStatusIndicatorProps> = ({ status }) => {
  const { classes } = useStyles();

  const statusText = useMemo(() => {
    switch (status) {
      case TournamentStatus.Pending:
        return 'Registration Open!';
      case TournamentStatus.Checkin:
        return 'Check-In';
      case TournamentStatus.Live:
        return 'Live!';
      case TournamentStatus.Finished:
        return 'Finished';
      case TournamentStatus.Canceled:
        return 'Canceled';
    }
  }, [status]);

  return (
    <Typography
      className={classNames(classes.root, {
        pending: [TournamentStatus.Pending, TournamentStatus.Checkin].includes(status),
        live: status === TournamentStatus.Live,
        finished: status === TournamentStatus.Finished,
        canceled: status === TournamentStatus.Canceled,
        failed: status === TournamentStatus.Failed,
      })}
    >
      {statusText}
    </Typography>
  );
};
